import React, { Fragment, useEffect, useState } from 'react';
import cn from 'classnames';
import { ReactComponent as GitHubOutlinedIcon } from './icons/githubOutlinedIcon.svg';
import { ReactComponent as LinkIcon } from './icons/linkIcon.svg';
import { ReactComponent as CrossIcon } from './icons/crossIcon.svg';
import styles from './Works.module.css';
import modalStyles from './Modal.module.css';
import ItemButton from './ItemButton';
import WorkModal from './WorkModal';
import Slider from './Slider';

const WorkItem = ({
    item,
    i,
    isMobile,
    isOpen,
    onTextToggler,
    hideText,
    worksItemRef,
    hoveredLi,
    showText,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => setIsModalOpen(false);

    useEffect(() => {
        if (isMobile && isModalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isModalOpen, isMobile]);

    return (
        <Fragment key={item.name + item.img}>
            <WorkModal isOpen={isModalOpen} onClose={closeModal}>
                <div className={modalStyles.modalContent}>
                    <div className={modalStyles.imageContainer}>
                        <Slider images={item.imgs} videos={item.videos} />
                    </div>
                    <h2>{item.name}</h2>
                    <p>{item.info}</p>
                    <div className={modalStyles.stack}>
                        {item.stack.map((s, i) => (
                            <span key={s}>
                                {' '}
                                {s} {item.stack.length - 1 !== i && '|'}
                            </span>
                        ))}
                    </div>
                    <div className={modalStyles.icons}>
                        {item.url && (
                            <a
                                href={item.url}
                                target='_blank'
                                rel='noreferrer'
                                className={cn(styles.icons, styles.absolute)}
                                aria-label='GitHub'
                            >
                                <LinkIcon className={styles.icon} />
                            </a>
                        )}{' '}
                        {item.gitHub && (
                            <a
                                href={item.gitHub}
                                target='_blank'
                                rel='noreferrer'
                                className={cn(styles.icons, styles.absolute)}
                                aria-label='GitHub'
                            >
                                <GitHubOutlinedIcon className={styles.icon} />
                            </a>
                        )}
                    </div>
                </div>
            </WorkModal>
            <div
                id={item.url}
                className={cn(styles.worksItem)}
                ref={worksItemRef}
                onClick={openModal}
            >
                <div
                    className={cn(styles.worksItemLink)}
                    aria-label='works-demonstration-picture'
                >
                    <div
                        className={cn(styles.worksItemImg, {
                            [styles.active]: hoveredLi === i && !isMobile,
                        })}
                    >
                        <img
                            src={item.imgs[0]}
                            alt='work images'
                            width='540'
                            height='340'
                        />

                        <div
                            className={cn(styles.worksItemInfo, {
                                [styles.active]: hoveredLi === i,
                            })}
                            onClick={(e) => isMobile && e.preventDefault()}
                        >
                            {isOpen && (
                                <ItemButton
                                    isMobile={isMobile}
                                    hoveredLi={hoveredLi}
                                    i={i}
                                    isOpen={isOpen}
                                    onHandler={onTextToggler}
                                    cross={true}
                                    icon={<CrossIcon />}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className={cn(styles.modalBack, {
                        [styles.modalBackActive]: hoveredLi === i && isMobile,
                    })}
                ></div>

                <div className={cn(styles.worksItemName)}>
                    <div
                        className={cn(styles.worksItemBg, {
                            [styles.active]: hoveredLi === i && !isMobile,
                        })}
                    ></div>
                    <h6
                        className={cn({
                            [styles.active]: hoveredLi === i && !isMobile,
                        })}
                    >
                        {item.name}
                    </h6>
                    <span>
                        {item.stack.map((s) => (
                            <span key={s}> {s} </span>
                        ))}
                    </span>
                    {item.gitHub && (
                        <a
                            href={item.gitHub}
                            target='_blank'
                            rel='noreferrer'
                            className={cn(styles.icons)}
                            aria-label='GitHub'
                            onClick={(e) => e.stopPropagation()}
                        >
                            <GitHubOutlinedIcon className={styles.icon} />
                        </a>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default WorkItem;
